import { render, staticRenderFns } from "./RegionsSales.vue?vue&type=template&id=c94e536e&"
import script from "./RegionsSales.vue?vue&type=script&lang=js&"
export * from "./RegionsSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports